
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons/faAsterisk';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faCloud } from '@fortawesome/free-solid-svg-icons/faCloud';
import { faCogs } from '@fortawesome/free-solid-svg-icons/faCogs';
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faFlag } from '@fortawesome/free-solid-svg-icons/faFlag';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faRoad } from '@fortawesome/free-solid-svg-icons/faRoad';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faSort } from '@fortawesome/free-solid-svg-icons/faSort';
import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';
import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faTasks } from '@fortawesome/free-solid-svg-icons/faTasks';
import { faThList } from '@fortawesome/free-solid-svg-icons/faThList';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faUsersCog } from '@fortawesome/free-solid-svg-icons/faUsersCog';
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit' //Custom6734 add icon
import { faQrcode } from '@fortawesome/free-solid-svg-icons/faQrcode' //Custom6734 add icon




import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo'
import { faVideoCamera } from '@fortawesome/free-solid-svg-icons/faVideoCamera'
import { faVideoSlash } from '@fortawesome/free-solid-svg-icons/faVideoSlash'
import { faVihara } from '@fortawesome/free-solid-svg-icons/faVihara'
import { faVirus } from '@fortawesome/free-solid-svg-icons/faVirus'
import { faVirusCovid } from '@fortawesome/free-solid-svg-icons/faVirusCovid'
import { faVirusCovidSlash } from '@fortawesome/free-solid-svg-icons/faVirusCovidSlash'
import { faViruses } from '@fortawesome/free-solid-svg-icons/faViruses'
import { faVoicemail } from '@fortawesome/free-solid-svg-icons/faVoicemail'



import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons/faCheckDouble'
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare'
import { faCheckToSlot } from '@fortawesome/free-solid-svg-icons/faCheckToSlot'


import { faCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt'
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons/faCalendarCheck'
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons/faCalendarDay'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons/faCalendarDays'
import { faCalendarMinus } from '@fortawesome/free-solid-svg-icons/faCalendarMinus'
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons/faCalendarPlus'
import { faCalendarTimes } from '@fortawesome/free-solid-svg-icons/faCalendarTimes'
import { faCalendarWeek } from '@fortawesome/free-solid-svg-icons/faCalendarWeek'
import { faCalendarXmark } from '@fortawesome/free-solid-svg-icons/faCalendarXmark'
import { faCamera } from '@fortawesome/free-solid-svg-icons/faCamera'
import { faCameraAlt } from '@fortawesome/free-solid-svg-icons/faCameraAlt'
import { faCameraRetro } from '@fortawesome/free-solid-svg-icons/faCameraRetro'
import { faCameraRotate } from '@fortawesome/free-solid-svg-icons/faCameraRotate'
import { faCampground } from '@fortawesome/free-solid-svg-icons/faCampground'
import { faCancel } from '@fortawesome/free-solid-svg-icons/faCancel'





import { faDeleteLeft } from '@fortawesome/free-solid-svg-icons/faDeleteLeft'
import { faDemocrat } from '@fortawesome/free-solid-svg-icons/faDemocrat'
import { faDesktop } from '@fortawesome/free-solid-svg-icons/faDesktop'
import { faDashboard } from '@fortawesome/free-solid-svg-icons/faDashboard'
import { faCopyright } from '@fortawesome/free-solid-svg-icons/faCopyright'
import { faCouch } from '@fortawesome/free-solid-svg-icons/faCouch'
import { faCow } from '@fortawesome/free-solid-svg-icons/faCow'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons/faCreditCard'
import { faCrop } from '@fortawesome/free-solid-svg-icons/faCrop'
import { faCropAlt } from '@fortawesome/free-solid-svg-icons/faCropAlt'
import { faCropSimple } from '@fortawesome/free-solid-svg-icons/faCropSimple'
import { faCross } from '@fortawesome/free-solid-svg-icons/faCross'
import { faBattery } from '@fortawesome/free-solid-svg-icons/faBattery'
import { faBattery0 } from '@fortawesome/free-solid-svg-icons/faBattery0'
import { faBattery2 } from '@fortawesome/free-solid-svg-icons/faBattery2'
import { faBattery3 } from '@fortawesome/free-solid-svg-icons/faBattery3'
import { faBattery4 } from '@fortawesome/free-solid-svg-icons/faBattery4'
import { faBattery5 } from '@fortawesome/free-solid-svg-icons/faBattery5'
import { faBatteryEmpty } from '@fortawesome/free-solid-svg-icons/faBatteryEmpty'
import { faBatteryHalf } from '@fortawesome/free-solid-svg-icons/faBatteryHalf'
import { faBatteryQuarter } from '@fortawesome/free-solid-svg-icons/faBatteryQuarter'
import { faBatteryThreeQuarters } from '@fortawesome/free-solid-svg-icons/faBatteryThreeQuarters'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp'

import { faToiletPaper } from '@fortawesome/free-solid-svg-icons/faToiletPaper'

import { faBolt } from '@fortawesome/free-solid-svg-icons/faBolt'
import { faBoltLightning } from '@fortawesome/free-solid-svg-icons/faBoltLightning'
import { faBomb } from '@fortawesome/free-solid-svg-icons/faBomb'



export function initFortAwesome(vue:any) {
  vue.component('font-awesome-icon', FontAwesomeIcon);

  library.add(
    faArrowLeft,
    faAsterisk,
    faBan,
    faBars,
    faBell,
    faBook,
    faCloud,
    faCogs,
    faDatabase,
    faEye,
    faFlag,
    faHeart,
    faHome,
    faList,
    faLock,
    faPencilAlt,
    faPlus,
    faRoad,
    faSave,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faSync,
    faTachometerAlt,
    faTasks,
    faThList,
    faTimes,
    faTimesCircle,
    faTrash,
    faUser,
    faUserPlus,
    faUsers,
    faUsersCog,
    faWrench,
    faEdit,
    faQrcode,
    faVideo,
    faVideoCamera,
    faVideoSlash,
    faVihara,
    faVirus,
    faVirusCovid,
    faVirusCovidSlash,
    faViruses,
    faVoicemail,
    faCheck,
    faCheckCircle,
    faCheckDouble,
    faCheckSquare,
    faCheckToSlot,
    faCalendar,
    faCalendarAlt,
    faCalendarCheck,
    faCalendarDay,
    faCalendarDays,
    faCalendarMinus,
    faCalendarPlus,
    faCalendarTimes,
    faCalendarWeek,
    faCalendarXmark,
    faCamera,
    faCameraAlt,
    faCameraRetro,
    faCameraRotate,
    faCampground,
    faCancel,

    faDeleteLeft,
    faDemocrat,
    faDesktop,
    faDashboard,
    faCopyright,
    faCouch,
    faCow,
    faCreditCard,
    faCrop,
    faCropAlt,
    faCropSimple,
    faCross,
    faBattery,
    faBattery0,
    faBattery2,
    faBattery3,
    faBattery4,
    faBattery5,
    faBatteryEmpty,
    faBatteryHalf,
    faBatteryQuarter,
    faBatteryThreeQuarters,
    faArrowUp,
    faToiletPaper,
    faBolt,
    faBoltLightning,
    faBomb,



  ); //Custom5639 add faEdit,faQrcode
}



/*

fa0
fa1
fa2
fa3
fa4
fa5
fa6
fa7
fa8
fa9
faA
faAd
faAdd
faAddressBook
faAddressCard
faAdjust
faAdjust
faAlignCenter
faAlignJustify
faAlignLeft
faAlignRight
faAllergies
faAmbulance
faAmericanSignLanguageInterpreting
faAnchor
faAnchorCircleCheck
faAnchorCircleExclamation
faAnchorCircleXmark
faAnchorLock
faAngleDoubleDown
faAngleDoubleLeft
faAngleDoubleRight
faAngleDoubleUp
faAngleDown
faAngleLeft
faAngleRight
faAnglesDown
faAnglesLeft
faAnglesRight
faAnglesUp
faAngleUp
faAngry
faAnkh
faAppleAlt
faAppleWhole
faArchive
faArchway
faAreaChart
faArrowAltCircleDown
faArrowAltCircleLeft
faArrowAltCircleRight
faArrowAltCircleUp
faArrowCircleDown
faArrowCircleLeft
faArrowCircleRight
faArrowCircleUp
faArrowDown
faArrowDown19
faArrowDown91
faArrowDownAZ
faArrowDownLong
faArrowDownShortWide
faArrowDownUpAcrossLine
faArrowDownUpLock
faArrowDownWideShort
faArrowDownZA
faArrowLeft
faArrowLeftLong
faArrowLeftRotate
faArrowPointer
faArrowRight
faArrowRightArrowLeft
faArrowRightArrowLeft
faArrowRightFromBracket
faArrowRightLong
faArrowRightRotate
faArrowRightToBracket
faArrowRightToCity
faArrowRightToFile
faArrowRotateBack
faArrowRotateBackward
faArrowRotateForward
faArrowRotateLeft
faArrowRotateRight
faArrows
faArrows
faArrowsAltH
faArrowsAltV
faArrowsDownToLine
faArrowsDownToPeople
faArrowsDownToPeople
faArrowsLeftRight
faArrowsLeftRightToLine
faArrowsRotate
faArrowsSpin
faArrowsSplitUpAndLeft
faArrowsToCircle
faArrowsToDot
faArrowsToEye
faArrowsTurnRight
faArrowsTurnToDots
faArrowsUpDown
faArrowsUpDownLeftRight
faArrowsUpToLine
faArrowsV
faArrowTrendDown
faArrowTrendUp
faArrowTurnDown
faArrowTurnUp
faArrowUp
faArrowUp19
faArrowUp91
faArrowUpAZ
faArrowUpAZ
faArrowUpFromBracket
faArrowUpFromGroundWater
faArrowUpLong
faArrowUpRightDots
faArrowUpRightFromSquare
faArrowUpShortWide
faArrowUpWideShort
faArrowUpZA
faAslInterpreting
faAssistiveListeningSystems
faAsterisk
faAt
faAtlas
faAtom
faAudioDescription
faAustralSign
faAutomobile
faAward
faB
faBaby
faBabyCarriage
faBackspace
faBackspace
faBackwardFast
faBackwardStep
faBacon
faBacteria
faBacterium
faBagShopping
faBahai
faBahtSign
faBalanceScale
faBalanceScaleLeft
faBalanceScaleRight
faBan
faBandage
faBandage
faBangladeshiTakaSign
faBank
faBanSmoking
faBarChart
faBarcode
faBars
faBarsProgress
faBarsStaggered
faBaseball
faBaseballBall
faBaseballBatBall
faBasketball
faBasketballBall
faBasketShopping
faBath
faBathtub
faBattery
faBattery0
faBattery2
faBattery3
faBattery4
faBattery5
faBattery5
faBatteryCar
faBatteryEmpty
faBatteryHalf
faBatteryQuarter
faBatteryThreeQuarters
faBatteryThreeQuarters
faBed
faBedPulse
faBeer
faBeerMugEmpty
faBell
faBellConcierge
faBellSlash
faBezierCurve
faBible
faBicycle
faBiking
faBinoculars
faBiohazard
faBirthdayCake
faBlackboard
faBlender
faBlenderPhone
faBlind
faBlog
faBold
faBolt
faBoltLightning
faBomb
faBone
faBong
faBook
faBookAtlas
faBookBible
faBookBookmark
faBookDead
faBookDead
faBookmark
faBookMedical
faBookOpen
faBookOpenReader
faBookQuran
faBookReader
faBookSkull
faBookTanakh
faBorderAll
faBorderNone
faBorderStyle
faBorderTopLeft
faBoreHole
faBottleDroplet
faBottleWater
faBowlFood
faBowlingBall
faBowlRice
faBox
faBoxArchive
faBoxArchive
faBoxes
faBoxesAlt
faBoxesPacking
faBoxOpen
faBoxTissue
faBraille
faBrain
faBrazilianRealSign
faBreadSlice
faBridge
faBridgeCircleCheck
faBridgeCircleExclamation
faBridgeCircleXmark
faBridgeLock
faBridgeWater
faBriefcase
faBriefcaseClock
faBriefcaseMedical
faBroadcastTower
faBroom
faBroomBall
faBrush
faBucket
faBug
faBugs
faBugSlash
faBuilding
faBuildingCircleArrowRight
faBuildingCircleCheck
faBuildingCircleExclamation
faBuildingCircleXmark
faBuildingColumns
faBuildingColumns
faBuildingLock
faBuildingNgo
faBuildingShield
faBuildingUn
faBuildingUser
faBuildingWheat
faBullhorn
faBullseye
faBurger
faBurn
faBurst
faBus
faBusAlt
faBusAlt
faBusSimple
faC
faCab
faCableCar
faCake
faCakeCandles
faCalculator
faCalendar
faCalendarAlt
faCalendarCheck
faCalendarDay
faCalendarDays
faCalendarMinus
faCalendarPlus
faCalendarTimes
faCalendarWeek
faCalendarXmark
faCamera
faCameraAlt
faCameraRetro
faCameraRotate
faCampground
faCancel
faCandyCane
faCannabis
faCapsules
faCar
faCarAlt
faCaravan
faCarBattery
faCarBurst
faCarBurst
faCarCrash
faCaretDown
faCaretLeft
faCaretRight
faCaretSquareDown
faCaretSquareLeft
faCaretSquareRight
faCaretUp
faCarOn
faCarRear
faCarriageBaby
faCarrot
faCarSide
faCartArrowDown
faCartFlatbed
faCartFlatbedSuitcase
faCartPlus
faCartShopping
faCarTunnel
faCashRegister
faCat
faCat
faCediSign
faCentSign
faCertificate
faChain
faChainBroken
faChainSlash
faChair
faChalkboard
faChalkboardTeacher
faChalkboardUser
faChampagneGlasses
faChargingStation
faChartArea
faChartBar
faChartColumn
faChartDiagram
faChartGantt
faChartLine
faChartPie
faChartSimple
faCheck
faCheckCircle
faCheckDouble
faCheckSquare
faCheckToSlot
faCheese
faChess
faChessBishop
faChessBoard
faChessKing
faChessKnight
faChessPawn
faChessQueen
faChessRook
faChevronCircleDown
faChevronCircleLeft
faChevronCircleRight
faChevronCircleUp
faChevronDown
faChevronLeft
faChevronRight
faChevronUp
faChild
faChildCombatant
faChildDress
faChildReaching
faChildren
faChildRifle
faChurch
faCircle
faCircleArrowDown
faCircleArrowLeft
faCircleArrowRight
faCircleArrowUp
faCircleCheck
faCircleChevronDown
faCircleChevronLeft
faCircleChevronRight
faCircleChevronUp
faCircleDollarToSlot
faCircleDot
faCircleDown
faCircleExclamation
faCircleH
faCircleHalfStroke
faCircleInfo
faCircleLeft
faCircleMinus
faCircleNodes
faCircleNotch
faCirclePause
faCirclePlay
faCirclePlus
faCircleQuestion
faCircleRadiation
faCircleRight
faCircleStop
faCircleUp
faCircleUser
faCircleXmark
faClapperboard
faClinicMedical
faClipboard
faClipboardCheck
faClipboardList
faClipboardQuestion
faClipboardUser
faClock
faClock
faClockRotateLeft
faClone
faClose
faClosedCaptioning
faCloud
faCloudArrowDown
faCloudArrowUp
faCloudBolt
faCloudDownload
faCloudDownloadAlt
faCloudMeatball
faCloudMoon
faCloudMoonRain
faCloudRain
faCloudShowersHeavy
faCloudShowersWater
faCloudSun
faCloudSunRain
faCloudUpload
faCloudUploadAlt
faClover
faCny
faCocktail
faCode
faCodeBranch
faCodeCommit
faCodeCompare
faCodeCompare
faCodeMerge
faCodePullRequest
faCoffee
faCog
faCogs
faCoins
faColonSign
faColumns
faComment
faCommentAlt
faCommentDollar
faCommentDots
faCommentDots
faCommentMedical
faCommentNodes
faComments
faCommentsDollar
faCommentSlash
faCommentSms
faCompactDisc
faCompass
faCompassDrafting
faCompress
faCompressAlt
faCompressArrowsAlt
faComputer
faComputerMouse
faConciergeBell
faContactBook
faContactCard
faCookie
faCookieBite
faCopy
faCopyright
faCouch
faCow
faCreditCard
faCreditCardAlt
faCrop
faCropAlt
faCropSimple
faCross
faCross
faCrow
faCrown
faCrutch
faCruzeiroSign
faCube
faCubes
faCubesStacked
faCut
faCutlery
faD
faDashboard
faDatabase
faDatabase
faDeaf
faDeafness
faDedent
faDeleteLeft
faDemocrat
faDesktop
faDesktopAlt
faDharmachakra
faDiagnoses
faDiagramNext
faDiagramPredecessor
faDiagramProject
faDiagramSuccessor
faDiamond
faDiamondTurnRight
faDice
faDiceD20
faDiceD6
faDiceFive
faDiceFour
faDiceOne
faDiceSix
faDiceThree
faDiceTwo
faDigging
faDigitalTachograph
faDirections
faDisease
faDisplay
faDivide
faDna
faDog
faDollar
faDollarSign
faDolly
faDollyBox
faDollyBox
faDonate
faDongSign
faDoorClosed
faDoorOpen
faDotCircle
faDove
faDownLeftAndUpRightToCenter
faDownload
faDownLong
faDraftingCompass
faDragon
faDrawPolygon
faDriversLicense
faDroplet
faDropletSlash
faDrum
faDrumSteelpan
faDrumstickBite
faDumbbell
faDumpster
faDumpster
faDungeon
faE
faEarDeaf
faEarListen
faEarth
faEarthAfrica
faEarthAmerica
faEarthAmericas
faEarthAmericas
faEarthEurope
faEarthOceania
faEdit
faEdit
faEgg
faElevator
faEllipsis
faEllipsis
faEllipsisV
faEllipsisV
faEnvelope
faEnvelopeCircleCheck
faEnvelopeOpen
faEnvelopeOpenText
faEnvelopesBulk
faEnvelopeSquare
faEquals
faEraser
faEthernet
faEur
faEuro
faEuroSign
faExchange
faExchangeAlt
faExclamation
faExclamationCircle
faExclamationTriangle
faExpand
faExpandAlt
faExpandArrowsAlt
faExplosion
faExternalLink
faExternalLinkAlt
faExternalLinkSquare
faExternalLinkSquareAlt
faEye
faEye
faEyeDropperEmpty
faEyeLowVision
faEyeSlash
faF
faFaceAngry
faFaceDizzy
faFaceFlushed
faFaceFrown
faFaceFrownOpen
faFaceGrimace
faFaceGrin
faFaceGrinBeam
faFaceGrinBeam
faFaceGrinHearts
faFaceGrinSquint
faFaceGrinSquintTears
faFaceGrinStars
faFaceGrinTears
faFaceGrinTongue
faFaceGrinTongueSquint
faFaceGrinTongueWink
faFaceGrinWide
faFaceGrinWink
faFaceKiss
faFaceKissBeam
faFaceKissWinkHeart
faFaceLaugh
faFaceLaughBeam
faFaceLaughSquint
faFaceLaughWink
faFaceMeh
faFaceMehBlank
faFaceRollingEyes
faFaceSadCry
faFaceSadTear
faFaceSmile
faFaceSmileBeam
faFaceSmileWink
faFaceSurprise
faFaceTired
faFan
faFastBackward
faFastForward
faFaucet
faFaucetDrip
faFax
faFax
faFeather
faFeatherAlt
faFeatherPointed
faFeed
faFemale
faFerry
faFighterJet
faFile
faFileAlt
faFileArchive
faFileArrowDown
faFileArrowUp
faFileAudio
faFileCircleCheck
faFileCircleExclamation
faFileCircleMinus
faFileCirclePlus
faFileCircleQuestion
faFileCircleXmark
faFileClipboard
faFileCode
faFileContract
faFileCsv
faFileDownload
faFileEdit
faFileExcel
faFileExport
faFileFragment
faFileHalfDashed
faFileImage
faFileImport
faFileInvoice
faFileInvoiceDollar
faFileLines
faFileMedical
faFileMedicalAlt
faFilePdf
faFilePen
faFilePowerpoint
faFilePrescription
faFileShield
faFileSignature
faFileText
faFileUpload
faFileVideo
faFileWaveform
faFileWord
faFileZipper
faFill
faFillDrip
faFilm
faFilter
faFilterCircleDollar
faFilterCircleXmark
faFingerprint
faFire
faFireAlt
faFireBurner
faFireExtinguisher
faFireFlameCurved
faFireFlameSimple
faFirstAid
faFish
faFishFins
faFlag
faFlagCheckered
faFlagUsa
faFlask
faFlaskVial
faFloppyDisk
faFlorinSign
faFlushed
faFolder
faFolderBlank
faFolderClosed
faFolderMinus
faFolderOpen
faFolderPlus
faFolderTree
faFont
faFont
faFontAwesomeFlag
faFontAwesomeLogoFull
faFootball
faFootballBall
faForward
faForward
faForwardStep
faFrancSign
faFrog
faFrown
faFrownOpen
faFunnelDollar
faFutbol
faFutbolBall
faG
faGamepad
faGasPump
faGasPump
faGaugeHigh
faGaugeMed
faGaugeMed
faGaugeSimpleHigh
faGaugeSimpleMed
faGavel
faGbp
faGbp
faGear
faGears
faGem
faGenderless
faGhost
faGift
faGlassCheers
faGlasses
faGlassMartini
faGlassMartiniAlt
faGlassWater
faGlassWaterDroplet
faGlassWhiskey
faGlobe
faGlobeAfrica
faGlobeAmericas
faGlobeAsia
faGlobeAsia
faGlobeOceania
faGolfBall
faGolfBallTee
faGopuram
faGraduationCap
faGreaterThan
faGreaterThan
faGrimace
faGrin
faGrinAlt
faGrinBeam
faGrinBeamSweat
faGrinBeamSweat
faGrinSquint
faGrinSquintTears
faGrinStars
faGrinTears
faGrinTongue
faGrinTongueSquint
faGrinTongueWink
faGrinWink
faGrip
faGrip
faGripLines
faGripLinesVertical
faGripVertical
faGroupArrowsRotate
faGuaraniSign
faGuitar
faGun
faH
faHamburger
faHammer
faHamsa
faHand
faHandBackFist
faHandcuffs
faHandcuffs
faHandDots
faHandFist
faHandHolding
faHandHoldingDollar
faHandHoldingDroplet
faHandHoldingHand
faHandHoldingHeart
faHandHoldingMedical
faHandHoldingWater
faHandLizard
faHandMiddleFinger
faHandPaper
faHandPeace
faHandPointDown
faHandPointer
faHandPointLeft
faHandPointRight
faHandPointUp
faHandRock
faHands
faHandsAmericanSignLanguageInterpreting
faHandsAslInterpreting
faHandsBound
faHandsBubbles
faHandScissors
faHandScissors
faHandsClapping
faHandshake
faHandshakeAlt
faHandshakeAltSlash
faHandshakeAngle
faHandshakeSimple
faHandshakeSimpleSlash
faHandshakeSlash
faHandsHelping
faHandsHolding
faHandsHoldingCircle
faHandSparkles
faHandSpock
faHandsPraying
faHandsWash
faHanukiah
faHardDrive
faHardHat
faHardOfHearing
faHashtag
faHatCowboy
faHatCowboySide
faHatHard
faHatWizard
faHaykal
faHdd
faHdd
faHeader
faHeading
faHeadphones
faHeadphonesAlt
faHeadphonesSimple
faHeadset
faHeadSideCough
faHeadSideCoughSlash
faHeadSideMask
faHeadSideVirus
faHeart
faHeartbeat
faHeartBroken
faHeartCircleBolt
faHeartCircleCheck
faHeartCircleExclamation
faHeartCircleMinus
faHeartCirclePlus
faHeartCircleXmark
faHeartCrack
faHeartMusicCameraBolt
faHeartPulse
faHelicopter
faHelicopterSymbol
faHelmetSafety
faHelmetUn
faHexagonNodes
faHexagonNodesBolt
faHighlighter
faHiking
faHillAvalanche
faHillRockslide
faHippo
faHockeyPuck
faHollyBerry
faHome
faHomeAlt
faHomeLg
faHomeLgAlt
faHomeUser
faHorse
faHorse
faHospital
faHospitalAlt
faHospitalSymbol
faHospitalUser
faHospitalWide
faHotdog
faHotel
faHotTub
faHotTubPerson
faHourglass
faHourglass1
faHourglass2
faHourglass3
faHourglass3
faHourglassEmpty
faHourglassEnd
faHourglassStart
faHouse
faHouseChimney
faHouseChimneyCrack
faHouseChimneyMedical
faHouseChimneyUser
faHouseChimneyWindow
faHouseCircleCheck
faHouseCircleExclamation
faHouseCircleXmark
faHouseCrack
faHouseDamage
faHouseDamage
faHouseFire
faHouseFlag
faHouseFloodWater
faHouseLaptop
faHouseLock
faHouseMedical
faHouseMedicalCircleCheck
faHouseMedicalCircleExclamation
faHouseMedicalCircleXmark
faHouseMedicalCircleXmark
faHouseSignal
faHouseTsunami
faHouseUser
faHryvnia
faHryvniaSign
faHSquare
faHurricane
faI
faIceCream
faIcicles
faIcons
faICursor
faIdBadge
faIdCard
faIdCardAlt
faIdCardClip
faIdCardClip
faIls
faImage
faImagePortrait
faImages
faInbox
faIndent
faIndianRupee
faIndianRupeeSign
faIndustry
faInfinity
faInfo
faInfoCircle
faInr
faInstitution
faItalic
faJ
faJar
faJarWheat
faJarWheat
faJedi
faJetFighter
faJoint
faJournalWhills
faJpy
faJugDetergent
faK
faKaaba
faKaaba
faKey
faKeyboard
faKhanda
faKipSign
faKiss
faKissBeam
faKissWinkHeart
faKitchenSet
faKitMedical
faKrw
faL
faLadderWater
faLandmark
faLandmarkAlt
faLandmarkAlt
faLandmarkFlag
faLandMineOn
faLanguage
faLaptop
faLaptop
faLaptopCode
faLaptopHouse
faLaptopMedical
faLariSign
faLaugh
faLaughBeam
faLaughSquint
faLaughWink
faLayerGroup
faLayerGroup
faLeaf
faLeftLong
faLeftRight
faLegal
faLemon
faLessThan
faLessThanEqual
faLevelDown
faLevelDownAlt
faLevelUp
faLevelUpAlt
faLifeRing
faLightbulb
faLineChart
faLinesLeaning
faLink
faLinkSlash
faLiraSign
faList
faList12
faListAlt
faListCheck
faListDots
faListNumeric
faListOl
faListSquares
faListUl
faLocation
faLocationArrow
faLocationCrosshairs
faLocationDot
faLocationPin
faLocationPinLock
faLock
faLockOpen
faLocust
faLongArrowAltDown
faLongArrowAltLeft
faLongArrowAltRight
faLongArrowAltUp
faLongArrowDown
faLongArrowLeft
faLongArrowRight
faLongArrowUp
faLowVision
faLuggageCart
faLungs
faLungsVirus
faM
faMagic
faMagicWandSparkles
faMagnet
faMagnifyingGlass
faMagnifyingGlassArrowRight
faMagnifyingGlassChart
faMagnifyingGlassDollar
faMagnifyingGlassLocation
faMagnifyingGlassMinus
faMagnifyingGlassPlus
faMailBulk
faMailForward
faMailReply
faMailReplyAll
faMale
faManatSign
faMap
faMapLocation
faMapLocationDot
faMapMarked
faMapMarkedAlt
faMapMarker
faMapMarkerAlt
faMapPin
faMapSigns
faMarker
faMars
faMarsAndVenus
faMarsAndVenusBurst
faMarsDouble
faMarsDouble
faMarsStrokeH
faMarsStrokeRight
faMarsStrokeUp
faMarsStrokeV
faMartiniGlass
faMartiniGlass
faMartiniGlassEmpty
faMartiniGlassEmpty
faMaskFace
faMasksTheater
faMaskVentilator
faMattressPillow
faMaximize
faMaximize
faMedal
faMedkit
faMeh
faMehBlank
faMehRollingEyes
faMemory
faMenorah
faMercury
faMessage
faMeteor
faMicrochip
faMicrophone
faMicrophoneAlt
faMicrophoneAltSlash
faMicrophoneLines
faMicrophoneLinesSlash
faMicrophoneSlash
faMicroscope
faMillSign
faMinimize
faMinus
faMinusCircle
faMinusSquare
faMobile
faMobileAlt
faMobileAndroid
faMobileAndroidAlt
faMobileButton
faMobilePhone
faMobileRetro
faMobileScreen
faMobileScreenButton
faMoneyBill
faMoneyBill1
faMoneyBill1Wave
faMoneyBillAlt
faMoneyBills
faMoneyBillTransfer
faMoneyBillTrendUp
faMoneyBillWave
faMoneyBillWaveAlt
faMoneyBillWheat
faMoneyCheck
faMoneyCheckAlt
faMoneyCheckDollar
faMonument
faMoon
faMortarBoard
faMortarPestle
faMosque
faMosquito
faMosquitoNet
faMotorcycle
faMound
faMountain
faMountainCity
faMountainSun
faMouse
faMousePointer
faMugHot
faMugSaucer
faMultiply
faMuseum
faMusic
faN
faNairaSign
faNavicon
faNavicon
faNetworkWired
faNeuter
faNotdef
faNotEqual
faNotesMedical
faNoteSticky
faO
faObjectGroup
faObjectUngroup
faObjectUngroup
faOilCan
faOm
faOtter
faOutdent
faP
faPager
faPaintbrush
faPaintRoller
faPalette
faPallet
faPanorama
faPaperclip
faPaperPlane
faParachuteBox
faParagraph
faParking
faPassport
faPastafarianism
faPaste
faPause
faPauseCircle
faPaw
faPaw
faPeace
faPen
faPenAlt
faPencil
faPencilAlt
faPencilRuler
faPencilSquare
faPenClip
faPenFancy
faPenNib
faPenRuler
faPenSquare
faPenToSquare
faPeopleArrows
faPeopleArrowsLeftRight
faPeopleCarry
faPeopleCarryBox
faPeopleGroup
faPeopleLine
faPeoplePulling
faPeopleRobbery
faPeopleRoof
faPepperHot
faPercent
faPercentage
faPerson
faPersonArrowDownToLine
faPersonArrowUpFromLine
faPersonBiking
faPersonBooth
faPersonBreastfeeding
faPersonBurst
faPersonCane
faPersonChalkboard
faPersonCircleCheck
faPersonCircleExclamation
faPersonCircleMinus
faPersonCirclePlus
faPersonCircleQuestion
faPersonCircleXmark
faPersonDigging
faPersonDotsFromLine
faPersonDress
faPersonDressBurst
faPersonDrowning
faPersonFalling
faPersonFallingBurst
faPersonHalfDress
faPersonHarassing
faPersonHiking
faPersonMilitaryPointing
faPersonMilitaryRifle
faPersonMilitaryToPerson
faPersonPraying
faPersonPregnant
faPersonRays
faPersonRifle
faPersonRunning
faPersonShelter
faPersonSkating
faPersonSkiing
faPersonSkiingNordic
faPersonSnowboarding
faPersonSwimming
faPersonThroughWindow
faPersonWalking
faPersonWalkingArrowLoopLeft
faPersonWalkingArrowRight
faPersonWalkingDashedLineArrowRight
faPersonWalkingLuggage
faPersonWalkingWithCane
faPesetaSign
faPesoSign
faPhone
faPhoneAlt
faPhoneFlip
faPhoneSlash
faPhoneSquare
faPhoneSquareAlt
faPhoneVolume
faPhotoFilm
faPhotoVideo
faPieChart
faPiggyBank
faPills
faPingPongPaddleBall
faPlaceOfWorship
faPlane
faPlaneArrival
faPlaneCircleCheck
faPlaneCircleExclamation
faPlaneCircleXmark
faPlaneDeparture
faPlaneLock
faPlaneSlash
faPlaneUp
faPlantWilt
faPlateWheat
faPlay
faPlayCircle
faPlug
faPlugCircleBolt
faPlugCircleCheck
faPlugCircleExclamation
faPlugCircleMinus
faPlugCirclePlus
faPlugCircleXmark
faPlus
faPlusCircle
faPlusMinus
faPlusSquare
faPodcast
faPoll
faPoll
faPoo
faPooBolt
faPoop
faPooStorm
faPortrait
faPoundSign
faPowerOff
faPray
faPray
faPrescription
faPrescriptionBottle
faPrescriptionBottleAlt
faPrescriptionBottleMedical
faPrint
faProcedures
faProjectDiagram
faPumpMedical
faPumpSoap
faPuzzlePiece
faQ
faQrcode
faQuestion
faQuestionCircle
faQuidditch
faQuidditchBroomBall
faQuoteLeft
faQuoteLeftAlt
faQuoteRight
faQuoteRightAlt
faQuran
faR
faRadiation
faRadiationAlt
faRadio
faRainbow
faRandom
faRankingStar
faRankingStar
faReceipt
faRecordVinyl
faRectangleAd
faRectangleList
faRectangleTimes
faRectangleXmark
faRecycle
faRedo
faRedoAlt
faRefresh
faRegistered
faRemove
faRemoveFormat
faReorder
faRepeat
faReply
faReplyAll
faRepublican
faRestroom
faRetweet
faRibbon
faRightFromBracket
faRightLeft
faRightLong
faRightToBracket
faRmb
faRoad
faRoadBarrier
faRoadBridge
faRoadCircleCheck
faRoadCircleExclamation
faRoadCircleXmark
faRoadLock
faRoadSpikes
faRobot
faRocket
faRodAsclepius
faRodSnake
faRotate
faRotateBack
faRotateBackward
faRotateBackward
faRotateLeft
faRotateRight
faRouble
faRoute
faRss
faRssSquare
faRub
faRuble
faRubleSign
faRug
faRuler
faRulerCombined
faRulerCombined
faRulerVertical
faRunning
faRupee
faRupeeSign
faRupiahSign
faS
faSackDollar
faSackXmark
faSadCry
faSadTear
faSailboat
faSatellite
faSatelliteDish
faSave
faScaleBalanced
faScaleBalanced
faScaleUnbalancedFlip
faSchool
faSchoolCircleCheck
faSchoolCircleExclamation
faSchoolCircleExclamation
faSchoolFlag
faSchoolLock
faScissors
faScrewdriver
faScrewdriverWrench
faScroll
faScrollTorah
faSdCard
faSdCard
faSearch
faSearchDollar
faSearchLocation
faSearchMinus
faSearchPlus
faSection
faSeedling
faServer
faShapes
faShare
faShareAlt
faShareAltSquare
faShareFromSquare
faShareNodes
faShareSquare
faSheetPlastic
faShekel
faShekelSign
faSheqel
faSheqelSign
faShield
faShieldAlt
faShieldBlank
faShieldCat
faShieldDog
faShieldHalved
faShieldHeart
faShieldVirus
faShip
faShippingFast
faShirt
faShoePrints
faShop
faShopLock
faShoppingBag
faShoppingBasket
faShoppingCart
faShopSlash
faShower
faShrimp
faShuffle
faShuttleSpace
faShuttleVan
faSign
faSignal
faSignal5
faSignalPerfect
faSignature
faSignHanging
faSignIn
faSignIn
faSigning
faSignLanguage
faSignOut
faSignOutAlt
faSignsPost
faSimCard
faSink
faSkating
faSkiing
faSkiingNordic
faSkull
faSkullCrossbones
faSlash
faSleigh
faSliders
faSliders
faSmile
faSmileBeam
faSmileWink
faSmog
faSmoking
faSmokingBan
faSms
faSnowboarding
faSnowflake
faSnowman
faSnowplow
faSoap
faSoccerBall
faSocks
faSolarPanel
faSort
faSortAlphaAsc
faSortAlphaDesc
faSortAlphaDown
faSortAlphaDownAlt
faSortAlphaUp
faSortAlphaUpAlt
faSortAmountAsc
faSortAmountDesc
faSortAmountDown
faSortAmountDownAlt
faSortAmountUp
faSortAmountUpAlt
faSortAsc
faSortDesc
faSortDown
faSortNumericAsc
faSortNumericDesc
faSortNumericDown
faSortNumericDownAlt
faSortNumericUp
faSortNumericUpAlt
faSortUp
faSpa
faSpaceShuttle
faSpaceShuttle
faSpellCheck
faSpider
faSpinner
faSplotch
faSpoon
faSprayCan
faSprayCanSparkles
faSprout
faSquare
faSquareArrowUpRight
faSquareBinary
faSquareCaretDown
faSquareCaretLeft
faSquareCaretRight
faSquareCaretUp
faSquareCheck
faSquareCheck
faSquareEnvelope
faSquareFull
faSquareMinus
faSquareNfi
faSquareParking
faSquarePen
faSquarePersonConfined
faSquarePhone
faSquarePhone
faSquarePlus
faSquarePollHorizontal
faSquarePollVertical
faSquareRootAlt
faSquareRootVariable
faSquareRss
faSquareShareNodes
faSquareUpRight
faSquareVirus
faSquareXmark
faStaffAesculapius
faStaffSnake
faStairs
faStamp
faStapler
faStar
faStarAndCrescent
faStarAndCrescent
faStarHalf
faStarHalfAlt
faStarOfDavid
faStarOfLife
faStepBackward
faStepForward
faSterlingSign
faStethoscope
faStickyNote
faStop
faStopCircle
faStopwatch
faStopwatch20
faStore
faStoreAlt
faStoreAltSlash
faStoreSlash
faStream
faStreetView
faStrikethrough
faStroopwafel
faSubscript
faSubtract
faSubway
faSuitcase
faSuitcaseMedical
faSuitcaseRolling
faSun
faSunPlantWilt
faSuperscript
faSurprise
faSwatchbook
faSwimmer
faSwimmingPool
faSynagogue
faSync
faSyncAlt
faSyringe
faT
faTable
faTableCells
faTableCellsColumnLock
faTableCellsLarge
faTableCellsRowLock
faTableCellsRowUnlock
faTableColumns
faTableList
faTablet
faTabletAlt
faTabletAndroid
faTabletAndroid
faTabletButton
faTableTennisPaddleBall
faTablets
faTabletScreenButton
faTachographDigital
faTachometer
faTachometer
faTachometerAltAverage
faTachometerAltFast
faTachometerAltFast
faTachometerFast
faTag
faTags
faTanakh
faTape
faTarp
faTarpDroplet
faTasks
faTasksAlt
faTaxi
faTaxi
faTeeth
faTeethOpen
faTeletype
faTelevision
faTemperature0
faTemperature1
faTemperature2
faTemperature3
faTemperature4
faTemperatureArrowDown
faTemperatureArrowUp
faTemperatureDown
faTemperatureEmpty
faTemperatureFull
faTemperatureHalf
faTemperatureHigh
faTemperatureLow
faTemperatureQuarter
faTemperatureThreeQuarters
faTemperatureUp
faTenge
faTengeSign
faTent
faTentArrowDownToLine
faTentArrowLeftRight
faTentArrowsDown
faTentArrowTurnLeft
faTents
faTerminal
faTextHeight
faTextSlash
faTextWidth
faTh
faTheaterMasks
faThermometer
faThermometer0
faThermometer1
faThermometer2
faThermometer3
faThermometer3
faThermometer4
faThermometerEmpty
faThermometerHalf
faThermometerQuarter
faThermometerThreeQuarters
faThLarge
faThList
faThumbsDown
faThumbsUp
faThumbtack
faThumbtackSlash
faThunderstorm
faTicket
faTicketAlt
faTicketSimple
faTimeline
faTimes
faTimesCircle
faTimesRectangle
faTimesSquare
faTint
faTintSlash
faToggleOff
faToggleOn
faToilet
faToiletPaper
faToiletPaperSlash
faToiletPortable
faToiletsPortable
faToolbox
faTools
faTooth
faTorah
faToriiGate
faTornado
faTowerBroadcast
faTowerCell
faTowerObservation
faTractor
faTrademark
faTrafficLight
faTrailer
faTrain
faTrainSubway
faTrainTram
faTram
faTransgender
faTransgenderAlt
faTrash
faTrashAlt
faTrashArrowUp
faTrashCan
faTrashCanArrowUp
faTrashRestore
faTrashRestoreAlt
faTree
faTreeCity
faTriangleCircleSquare
faTriangleExclamation
faTrophy
faTrowel
faTrowelBricks
faTruck
faTruckArrowRight
faTruckDroplet
faTruckDroplet
faTruckFast
faTruckField
faTruckFieldUn
faTruckLoading
faTruckMedical
faTruckMonster
faTruckMoving
faTruckPickup
faTruckPlane
faTruckRampBox
faTry
faTShirt
faTty
faTurkishLira
faTurkishLiraSign
faTurnDown
faTurnUp
faTv
faTvAlt
faU
faUmbrella
faUmbrellaBeach
faUnderline
faUndo
faUndoAlt
faUniversalAccess
faUniversity
faUnlink
faUnlock
faUnlockAlt
faUnlockKeyhole
faUnsorted
faUpDown
faUpDownLeftRight
faUpload
faUpLong
faUpRightAndDownLeftFromCenter
faUpRightFromSquare
faUsd
faUser
faUserAlt
faUserAltSlash
faUserAstronaut
faUserCheck
faUserCircle
faUserClock
faUserCog
faUserDoctor
faUserDoctor
faUserEdit
faUserFriends
faUserGear
faUserGraduate
faUserGroup
faUserLarge
faUserLargeSlash
faUserLock
faUserMd
faUserMinus
faUserNinja
faUserNurse
faUserPen
faUserPlus
faUsers
faUsersBetweenLines
faUsersCog
faUsersCog
faUserSecret
faUsersGear
faUserSlash
faUsersLine
faUsersRays
faUsersRectangle
faUsersSlash
faUsersViewfinder
faUserTag
faUserTie
faUserTimes
faUserXmark
faUtensils
faUtensilSpoon
faV
faVanShuttle
faVault
faVcard
faVcard
faVectorSquare
faVenus
faVenusDouble
faVenusMars
faVest
faVestPatches
faVial
faVialCircleCheck
faVials
faVialVirus
faVideo
faVideoCamera
faVideoSlash
faVihara
faVirus
faVirusCovid
faVirusCovidSlash
faViruses
faVoicemail
faVolcano
faVolleyball
faVolleyballBall
faVolumeControlPhone
faVolumeDown
faVolumeHigh
faVolumeLow
faVolumeMute
faVolumeOff
faVolumeTimes
faVolumeUp
faVolumeXmark
faVoteYea
faVrCardboard
faW
faWalkieTalkie
faWalking
faWallet
faWandMagic
faWandMagicSparkles
faWandSparkles
faWarehouse
faWarning
faWater
faWaterLadder
faWaveSquare
faWebAwesome
faWebAwesome
faWeightHanging
faWeightScale
faWheatAlt
faWheatAwn
faWheatAwnCircleExclamation
faWheelchair
faWheelchairAlt
faWheelchairMove
faWhiskeyGlass
faWifi
faWifi3
faWifiStrong
faWind
faWindowClose
faWindowMaximize
faWindowMinimize
faWindowRestore
faWineBottle
faWineGlass
faWineGlass
faWineGlassEmpty
faWon
faWonSign
faWorm
faX
faXmark
faXmarkCircle
faXmarksLines
faXmarkSquare
faXRay
faY
faY
faYen
faYenSign
faZ
faZap




*/